export const APLAUT_AVAILABILITY_PROP = 'aplaut_availability';

export const CATALOG_SORT_PROP = 'catalog_sort_default';

export const TRIGGER_FREE_SHIPPING_LIMIT_NOT_EXCEEDED_PROP = 'trigger.addToCart.freeShippingLimitNotExceeded';
export const TRIGGER_FREE_SHIPPING_LIMIT_EXCEEDED_PROP = 'trigger.addToCart.freeShippingLimitExceeded';
export const TRIGGER_CHOICE_BEST_SHIPPING_GROUP_PROP = 'trigger.ChoiceShippingGroup.ChoiceBestShippingGroup';
export const TRIGGER_PAY_ONLINE_FOR_LONGER_STORAGE_PERIOD_PROP = 'trigger.ChoiceShippingGroup.PayOnlineForLongerStorage';

export const STORAGE_TIME_FOR_PICKUP_TITLE = 'storageTimeForPickupText';
export const STORAGE_TIME_FOR_PICKUP_DESCRIPTION = 'storageTimeForPickupDescription';
export const EXTENSION_ORDER_PICKPOINT_CDEK_TEXT = 'extensionOrderPickpoint.cdek.windowText';
